import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import { get } from 'lodash-es';
import { BehaviorSubject, fromEvent, timer } from 'rxjs';
import { debounce, map } from 'rxjs/operators';
class ViewportModule {
  static {
    this.ɵfac = function ViewportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ViewportModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ViewportModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [WindowModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewportModule, [{
    type: NgModule,
    args: [{
      imports: [WindowModule]
    }]
  }], null, null);
})();
class ViewportService {
  constructor(window) {
    this.window = window;
    this.breakpoints = {
      a: 320,
      b: 480,
      c: 600,
      d: 768,
      e: 1024,
      f: 1200
    };
    const detectedViewport = this.detect();
    this.viewport$ = new BehaviorSubject(detectedViewport);
    this.viewport$.next(detectedViewport); // Detect on initial Load
    fromEvent(this.window, 'resize') // Detect on windows resize
    .pipe(debounce(() => timer(200)), map(event => this.detect(event))).subscribe(viewportInfo => this.viewport$.next(viewportInfo));
  }
  detect(event) {
    const width = get(event, 'currentTarget.innerWidth') || get(this.window, 'innerWidth'),
      height = get(event, 'currentTarget.innerHeight') || get(this.window, 'innerHeight');
    this.viewportType = 'mobile';
    if (width > this.breakpoints.b && width < this.breakpoints.e) {
      this.viewportType = 'tablet';
    } else if (width >= this.breakpoints.e) {
      this.viewportType = 'desktop';
    }
    const viewport = this.viewportType;
    if (this.viewport !== viewport) {
      this.viewport = viewport;
    }
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return {
      width,
      height,
      viewport,
      isMobileDevice
    };
  }
  static {
    this.ɵfac = function ViewportService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ViewportService)(i0.ɵɵinject(WINDOW));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ViewportService,
      factory: ViewportService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewportService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }], null);
})();

/*
 * Public API Surface of viewport
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ViewportModule, ViewportService };
